// extracted by mini-css-extract-plugin
export default {"container":"LiveCountdown_container__x1Zum","timeToStartContainer":"LiveCountdown_timeToStartContainer__KdPKJ","typographyCountdown":"LiveCountdown_typographyCountdown__CC93j"};